import React, { component } from 'react';

import Modal from '.';
import Button from '../button/index';
import ButtonV2 from '../button/button_v2';

import UndrawAlert from "../../assets/icons/undraw-alert.svg";

import { theme } from '../../styles/theme';
import { BodyG, H1, H5 } from '../../styles/stylesTypography';
import { ModalBody, ModalFooter, ModalTitle } from './styles';

class ModalNew extends React.Component {
    constructor(props) {
        super(props);
    }

    updateResponseYes = () => {
        let resposta = 1;
        this.props.update(resposta);
    }

    updateResponseNo = () => {
        let resposta = 0;
        this.props.update(resposta);
    }

    render() {
        return (
            <Modal
                {...this.props}
                align='center' // center, end, start
                justify='center' // center, end, start
                responsive
                width='50%'
            >
                {this.props.title === 'Atenção!' || this.props.title === 'Atenção' ? (
                    <img
                        src={UndrawAlert}
                        alt="Alerta"
                        style={{ width: '11rem', display: 'block', margin: '0 auto 0.75rem auto' }}
                    />
                ) : null}
               
                <ModalTitle> 
                    <H5 color={theme.colors.gray.Cinza_2}>
                        {this.props.title} 
                    </H5>
                </ModalTitle>

                <ModalBody>
                    <BodyG color={theme.colors.gray.Cinza_5}>
                        {this.props.text}
                    </BodyG>
                </ModalBody>

                <ModalFooter justifyContent='center' style={{ padding: "20px", paddingBottom: "1.5rem", gap: "2rem" }}>
                    {this.props.btnNo === true ? (
                        <ButtonV2 
                            width="100px"
                            height="48px"
                            outline
                            onClick={() => this.updateResponseNo()}
                            value={(this.props.state === 'GO' || this.props.state === 'DF') && this.props.type === 'nfe' ? 'VOLTAR' : 'NÃO'}
                        />
                    ):(
                        <ButtonV2 
                            width="100px"
                            height="48px"
                            outline
                            onClick={() => this.updateResponseNo()}
                            value="CANCELAR"
                        />
                    )}

                    <ButtonV2 
                        width="100px"
                        height="48px"
                        onClick={() => this.updateResponseYes()}
                        value={(this.props.state === 'GO' || this.props.state === 'DF') && this.props.type === 'nfe' ? 'ENTENDI' : 'SIM'}
                    />
                </ModalFooter>
            </Modal>

        );
    }
}
export default ModalNew;